document.addEventListener("DOMContentLoaded", () => {
  const sidebar = document.getElementById("sidebar")
  const backdrop = document.getElementById("sidebar-backdrop")
  const toggle = document.querySelector("[data-sidebar-toggle]")
  if (!sidebar || !backdrop || !toggle) return

  const open = () => {
    sidebar.classList.remove("-translate-x-full")
    backdrop.classList.remove("hidden")
  }
  const close = () => {
    sidebar.classList.add("-translate-x-full")
    backdrop.classList.add("hidden")
  }

  toggle.addEventListener("click", open)
  backdrop.addEventListener("click", close)

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close()
  })

  sidebar.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      if (window.innerWidth < 1024) close()
    })
  })
})
